import I18n from 'i18n-js'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router'

import FilterContentLayoutWrapper from '../shared/FilterContentLayoutWrapper'

import RetailerSettingsAutomations from './RetailerSettingsAutomations'
import RetailerSettingsBrandSettingsLayout from './RetailerSettingsBrandSettingsLayout'
import RetailerSettingsBusinessInfo from './RetailerSettingsBusinessInfo'
import retailerSettingsPaths from './retailerSettingsPaths'
import RetailerSettingsSocialAccounts from './RetailerSettingsSocialAccounts'
import RetailerSettingsUsers from './RetailerSettingsUsers'

const RetailerSettingsLayout: React.FC = () => {
  const params = retailerSettingsPaths.index.useParams()

  let selectedTab = ''
  if (retailerSettingsPaths.businessInfo.match()) {
    selectedTab = 'businessInfo'
  } else if (retailerSettingsPaths.socialAccounts.match()) {
    selectedTab = 'socialAccounts'
  } else if (retailerSettingsPaths.automations.match()) {
    selectedTab = 'automations'
  } else if (retailerSettingsPaths.brandSettings.match()) {
    selectedTab = 'brandSettings'
  } else if (retailerSettingsPaths.users.match()) {
    selectedTab = 'users'
  }

  return (
    <>
      <FilterContentLayoutWrapper
        title={I18n.t('retailerSettings.title')}
        slotProps={{
          tab: {
            selectedTab,
            tabs: [
              {
                value: 'businessInfo',
                label: I18n.t('retailerSettings.businessInfo.title'),
                to: retailerSettingsPaths.businessInfo.build({
                  retailerAccountSlug: params.retailerAccountSlug,
                }),
              },
              {
                value: 'socialAccounts',
                label: I18n.t('retailerSettings.socialAccounts.title'),
                to: retailerSettingsPaths.socialAccounts.build({
                  retailerAccountSlug: params.retailerAccountSlug,
                }),
              },
              {
                value: 'automations',
                label: I18n.t('retailerSettings.automations.title'),
                to: retailerSettingsPaths.automations.build({
                  retailerAccountSlug: params.retailerAccountSlug,
                }),
              },
              {
                value: 'brandSettings',
                label: I18n.t('retailerSettings.brandSettings.title'),
                to: retailerSettingsPaths.brandSettings.build({
                  retailerAccountSlug: params.retailerAccountSlug,
                }),
              },
              {
                value: 'users',
                label: I18n.t('retailerSettings.users.title'),
                to: retailerSettingsPaths.users.build({
                  retailerAccountSlug: params.retailerAccountSlug,
                }),
              },
            ],
          },
        }}
      >
        <Switch>
          <Route
            path={retailerSettingsPaths.businessInfo.path}
            component={RetailerSettingsBusinessInfo}
          />
          <Route
            path={retailerSettingsPaths.socialAccounts.path}
            component={RetailerSettingsSocialAccounts}
          />
          <Route
            path={retailerSettingsPaths.automations.path}
            component={RetailerSettingsAutomations}
          />
          <Route
            path={retailerSettingsPaths.brandSettings.path}
            component={RetailerSettingsBrandSettingsLayout}
          />
          <Route
            path={retailerSettingsPaths.users.path}
            component={RetailerSettingsUsers}
          />

          <Redirect
            from={retailerSettingsPaths.index.path}
            to={retailerSettingsPaths.businessInfo.build({
              retailerAccountSlug: params.retailerAccountSlug,
            })}
          />
        </Switch>
      </FilterContentLayoutWrapper>
    </>
  )
}

export default RetailerSettingsLayout
